module.exports = __webpack_public_path__ + "static/media/winelogo.c5562ced.png";